import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import {
  DEFAULT_FONT_SIZE,
  FONT_SIZE_TO_MUI,
  applyFontSize,
  getStoredFontSize,
  persistFontSize,
} from '../Utils/fontSize';

const FontSizeContext = createContext({
  fontSize: DEFAULT_FONT_SIZE,
  muiFontSize: FONT_SIZE_TO_MUI[DEFAULT_FONT_SIZE],
  setFontSize: () => {},
});

export const FontSizeProvider = ({ children }) => {
  const [fontSize, setFontSizeState] = useState(() => applyFontSize(getStoredFontSize()));

  const setFontSize = useCallback((value) => {
    setFontSizeState(persistFontSize(value));
  }, []);

  const value = useMemo(
    () => ({
      fontSize,
      muiFontSize: FONT_SIZE_TO_MUI[fontSize] ?? FONT_SIZE_TO_MUI[DEFAULT_FONT_SIZE],
      setFontSize,
    }),
    [fontSize, setFontSize],
  );

  return (
    <FontSizeContext.Provider value={value}>
      {children}
    </FontSizeContext.Provider>
  );
};

export const useFontSize = () => useContext(FontSizeContext);
